var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckbox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.33333 2H12.6667C13.4 2 14 2.6 14 3.33333V4L12.6667 5.33333V3.33333H3.33333V12.6667H12.6667V7.33333L14 6V12.6667C14 13.4 13.4 14 12.6667 14H3.33333C2.6 14 2 13.4 2 12.6667V3.33333C2 2.6 2.6 2 3.33333 2Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.0896 2.58048C14.4259 2.25641 14.9582 2.2562 15.2948 2.58002C15.65 2.92175 15.65 3.49018 15.2949 3.83196L8.19092 10.6692C7.80509 11.0405 7.19521 11.042 6.80756 10.6726L4.60698 8.57538C4.24707 8.23237 4.24773 7.6579 4.60842 7.31571C4.94414 6.99722 5.47053 6.99764 5.80574 7.31666L7.50087 8.92993L14.0896 2.58048Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckbox);
export default __webpack_public_path__ + "static/media/checkbox.0407a2f2.svg";
export { ForwardRef as ReactComponent };